import request from "@/utils/request";

// 查询新人专场内容
export function getNewcomerDetail() {
  return request({
    url: '/product/newbie/h5/queryNewbie',
    method: 'get'
  })
}
// 查询新人专场列表
export function getNewcomerList() {
  return request({
    url: '/product/special-newbie/h5/list',
    method: 'get',
  })
}